import { PersistentCache } from "./persistent_cache.js";

const OFFSET_KEY = "clock_offset_ms";
const MAX_SANE_OFFSET_MS = 365 * 24 * 60 * 60_000;
const PERSIST_DRIFT_MS = 2_000;

export class ServerClock
{
  private static offset_ms = ServerClock.readStoredOffset();

  public static noteResponseDate( header: string | null ): void
  {
    if ( !header ) return;
    const server_ms = Date.parse( header );
    if ( !Number.isFinite( server_ms ) ) return;

    const offset = server_ms - Date.now();
    if ( Math.abs( offset ) > MAX_SANE_OFFSET_MS ) return;

    const drifted = Math.abs( offset - this.offset_ms ) >= PERSIST_DRIFT_MS;
    this.offset_ms = offset;
    if ( drifted ) PersistentCache.write( OFFSET_KEY, offset );
  }

  public static nowMs(): number
  {
    return Date.now() + this.offset_ms;
  }

  public static getOffsetMs(): number
  {
    return this.offset_ms;
  }

  private static readStoredOffset(): number
  {
    const stored = PersistentCache.read<number>( OFFSET_KEY );
    return typeof stored === "number" && Number.isFinite( stored ) ? stored : 0;
  }
}
